import React from 'react';
import { Content, ButtonToolbar } from 'rsuite';
import InventoryPageLayout from '../../../../containers/inventory/PageLayout';
import PageHeader from '../../../../components/PageHeader';
import InventoryItemsAvailabilityList from '../../../../containers/inventory/ItemsAvailabilityList';
import { ItemType } from '../../../../constants/inventory/InventoryTypes';
import ItemAvailabilitySearch from '../../../../containers/inventory/ItemAvailabilitySearch';

export default () => (
  <InventoryPageLayout>
    <PageHeader title="On Hand Report">
      <ButtonToolbar>
        <ItemAvailabilitySearch type={ItemType} isReport />
      </ButtonToolbar>
    </PageHeader>
    <Content>
      <InventoryItemsAvailabilityList />
    </Content>
  </InventoryPageLayout>
);
